export const data=  [
    {
      "question": "What is the capital of Japan?",
      "options": ["Beijing", "Seoul", "Tokyo", "Bangkok"],
      "answer": "Tokyo"
    },
    {
      "question": "Who wrote 'Romeo and Juliet'?",
      "options": ["Charles Dickens", "Jane Austen", "William Shakespeare", "F. Scott Fitzgerald"],
      "answer": "William Shakespeare"
    },
    {
      "question": "What is the largest planet in our solar system?",
      "options": ["Venus", "Mars", "Earth", "Jupiter"],
      "answer": "Jupiter"
    },
    {
      "question": "Which gas do plants absorb from the atmosphere during photosynthesis?",
      "options": ["Oxygen", "Carbon Dioxide", "Methane", "Nitrogen"],
      "answer": "Carbon Dioxide"
    },
    {
      "question": "Who is known as the 'Father of Modern Physics'?",
      "options": ["Albert Einstein", "Isaac Newton", "Galileo Galilei", "Niels Bohr"],
      "answer": "Albert Einstein"
    },
    {
      "question": "What is the chemical symbol for gold?",
      "options": ["Go", "Gd", "Au", "Ag"],
      "answer": "Au"
    },
    {
      "question": "Which continent is known as the 'Dark Continent'?",
      "options": ["Africa", "Antarctica", "Asia", "South America"],
      "answer": "Africa"
    },
    {
      "question": "Who is the lead singer of the rock band 'Queen'?",
      "options": ["John Lennon", "Mick Jagger", "Freddie Mercury", "Axl Rose"],
      "answer": "Freddie Mercury"
    },
    {
      "question": "What is the chemical symbol for water?",
      "options": ["H2O", "CO2", "NaCl", "O2"],
      "answer": "H2O"
    },
    {
      "question": "Who wrote the play 'Hamlet'?",
      "options": ["George Orwell", "Emily Bronte", "William Shakespeare", "Herman Melville"],
      "answer": "William Shakespeare"
    }
  ]
  
  